interface CountryOption {
  name: string;
  code: string;
}

export const createOptionPostalCode = (item: Record<string, unknown>) => {
  const loc = item as unknown as Locations;
  return {
    label: `${loc.postalCode} - ${loc.city}`,
    value: `${loc.postalCode} - ${loc.city}`,
    data: loc,
  };
};

export const createOptionCity = (item: Record<string, unknown>) => {
  const loc = item as unknown as Locations;
  return { label: loc.city, value: loc.id!, data: loc };
};

export const createOptionCountry = (item: Record<string, unknown> | CountryOption) => {
  const { name, code } = item as CountryOption;
  return { label: name, value: code };
};
